var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"v-toggle",class:{ disabled: _vm.disabled },attrs:{"for":_vm.id}},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled,"id":_vm.id},domProps:{"checked":_vm.checked},on:{"change":function($event){return _vm.onChange($event)}}}),_vm._m(0),_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"toggle"},[_c('span',{staticClass:"handle"})])
}]

export { render, staticRenderFns }